import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { apiClient } from "@apis/apiClient";
import SntHideLongText from "../../../components/ReactBootstrap/SntHideLongText";
import StringUtils from "../../../utils/StringUtils";

function SearchItem({ dataSearch, closePopup, isRecent, language, strSearch }) {
  const history = useHistory();
  const [showMoreButton, setShowMoreButton] = useState(true);
  const [list, setList] = useState(dataSearch?.listItem.slice(0, 4));
  const [listData] = useState(dataSearch?.listItem);
  const [maxList] = useState(dataSearch.listItem.length);
  const [limitList, setLimitList] = useState(8);

  const showMore = () => {
    setList(listData.slice(0, limitList + maxList));
    setLimitList(limitList + maxList);
    if (listData.slice(0, limitList + maxList).length === maxList) {
      setShowMoreButton(false);
    }
  };

  const showLess = () => {
    setList(listData.slice(0, 4));
    setLimitList(4);
    setShowMoreButton(true);
  };

  const searchRender = useMemo(() => {
    return (
      <>
        <a href="##">
          {language["search_category_" + dataSearch.name + "_name"] ||
            dataSearch.name}
        </a>
        <ul className="ms-3">
          {list.map((item, index) => {
            return (
              <a
                key={index}
                href={apiClient.defaults.baseURL + item.link}
                className="chat-name"
                onClick={(e) => {
                  e.preventDefault();
                  history.push(item.link);
                  closePopup();
                }}
                title={item?.data.title}
              >
                <li id={item?.id}>
                  <div style={{ overflow: "hidden" }}>
                    {item?.img}
                    <div>
                      <SntHideLongText>{item?.data.title}</SntHideLongText>
                      <p style={{ margin: 0 }} className="subtitle-text">
                        {item?.data.subtitle
                          ? item?.data.subtitle
                          : item?.data.title}
                      </p>
                    </div>
                  </div>
                </li>
              </a>
            );
          })}
        </ul>
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch, list]);

  useEffect(() => {
    isRecent
      ? setList(dataSearch.listItem)
      : setList(dataSearch.listItem.slice(0, 4));
  }, [dataSearch, dataSearch.listItem, isRecent]);

  return (
    <div>
      <li>
        {searchRender}
        {showMoreButton && maxList > 4 && (
          <a
            className="more "
            href="# "
            onClick={(e) => {
              e.preventDefault();
              showMore();
            }}
            style={{ color: "#5094BE", fontSize: 14, fontWeight: "normal" }}
          >
            {!isRecent &&
              StringUtils.replaceStr(
                language.v41_view_all_matching_key,
                dataSearch.name.toLowerCase()
              ) +
                ' "' +
                strSearch +
                '"'}
          </a>
        )}
        {!showMoreButton && (
          <a
            className="more "
            href="# "
            onClick={(e) => {
              e.preventDefault();
              showLess();
            }}
            style={{ color: "#5094BE", fontSize: 14, fontWeight: "normal" }}
          >
            <u>{language.v41_show_less_key}</u>
          </a>
        )}
      </li>
    </div>
  );
}

SearchItem.propTypes = {};

export default SearchItem;
